import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleAvailabilityTrackingOptionsDto } from './create-vehicle-availability-tracking-options.dto';

/**
 * Update vehicle availability tracking options DTO
 */
export class UpdateVehicleAvailabilityTrackingOptionsDto extends CreateVehicleAvailabilityTrackingOptionsDto {
	@TransformInt()
	id!: number;
}
